import React, { useState, useEffect,useRef } from "react";
import axios from 'axios';
import { getUserId,aPIURL,auTHURL } from '../../utils/common';
import Modal from '../Modal';
//import LoadingSpinner from "../LoadingSpinner";
import ReactPaginate from "react-paginate";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useReactToPrint } from 'react-to-print';
//import { useDownloadExcel } from "react-export-table-to-excel";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
//import Enumerate from "linq";


const CDriverList = () => 
{
  const fileType ="xlsx";
  const tableRef = useRef(null);
  const [fdriverName,setFDriverName]=useState("");
  const [fcontactName,setFContactName]=useState("");
  const [flicenceName,setFlicenceName]=useState("");
  
  const [temppost, setTempPost] = useState([]);
  const [searchpost, setSearchempPost] = useState([]);
  let [arrayPriority, setarrayPriority] = useState([]);
  let [arrayAlertType, setarrayAlertType] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
    
  const API_URL=aPIURL();
  let [sno, setSno]  = useState(1);
  const [userId, setUserId]  = useState({});
  const [inputs, setInputs] = useState({});
  const [inputsEdit, setInputsEdit] = useState({});
  const [post, setPost] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [number, setNumber] = useState(1); 
  const [postPerPage] = useState(10);
  const [dCountryData, setDCountryData]= useState([]);
  const [dStateData, setDStateData]= useState([]);
  const [showAddDriver, setShowAddDriver]= useState(false);
  const [viewDriver, setViewDriver]= useState(false);
  const [showEditDriver, setShowEditDriver]= useState(false);
  const [lCountryID, setLCountryID]= useState(0);
  const [lStateID, setLStateID]= useState(0);
  const [rCountryID, setRCountryID]= useState(0);
  const [rIdType, setRIdType]= useState(0);
  const [rStateID, setRStateID]= useState(0);
  const [idTypeData, setIdTypeData]= useState([]);
  
  const [sDriverName, setSDriverName] = useState();
  const [sFatherName, setSFatherName ]= useState();
  const [sContactNumber, setSContactNumber ]= useState();
  const [sLicenceNumber, setSLicenceNumber ]= useState();
  const [sLicenceIssueFrom, setSLicenceIssueFrom ]= useState();
  const [sLicenceValidity, setSLicenceValidity ]= useState();
  const [sLicenceCountry, setSLicenceCountry ]= useState(0);
  const [sLicenceState, setSLicenceState ]= useState(0);
  const [sAddress, setSAddress ]= useState();
  const [sResidenceCountry, setSResidenceCountry ]= useState(0);
  const [sResidenceState, setSResidenceState ]= useState(0);
  const [sIdentityNumber, setSIdentityNumber ]= useState();
  const [sIdType, setSIdType]= useState();
  const [eRCountryID,setERCountryID] =useState(0);
  const [eIdType, setEIdType]= useState(0);
  const [eRStateID, setERStateID] = useState(0);
  const [eLCountryID,setELCountryID] =useState(0);
  const [eLStateID,	setELStateID] =useState(0);
  const [order, setOrder] = useState("ASC");
  const [statusId, setStatusId]= useState(0);
/*
  const [vCategoryData, setVCategoryData]= useState([]);
  
  const [vCategoryID, setVCategoryID]= useState(0);
  const [vCountryID, setVCountryID]= useState(0);
  const [vStateID, setVStateID]= useState(0);
  const [sVehicleNo, setSVehicleNo]= useState();                    
  const [sPlateNo, setSPlateNo]= useState();                              
  const [sVehicleType, setSVehicleType]= useState();                             
  const [sVIN, setSVIN]= useState();   
  const [sMake, setSMake]= useState();                        
  const [sModel, setSModel]= useState();                          
  const [sYear, setSYear]= useState();                          
  const [sEngineNo, setSEngineNo]= useState();                           
  const [sIMEINo, setSIMEINo]= useState();  
  const [sFASTag, setSFASTag]= useState();  
  const [sCountry, setSCountry]= useState();  
  const [sState, setSState]= useState();       
  const [veCategoryID, setVeCategoryID]= useState(0);
 */


useEffect(() => 
  {
            
            FillGrid(0);
  }, []);
  
  const lastPost = number * postPerPage;
  const firstPost = lastPost - postPerPage;
  const currentPost = post.slice(firstPost, lastPost);
  const PageCount = Math.ceil(post.length / postPerPage);

const FillGrid=(Type_ID)=>
{
  setIsLoading(true);
  const user_id = getUserId(); 
  setUserId(user_id);
  const curls=API_URL+`DriverList?AccountID=${user_id}&TypeID=${Type_ID}`;
 
  setTempPost([]);
  setPost([]);
  axios.get(curls).then(response => 
    {   
      setIsLoading(false);                         
      setPost(response.data.data)
      setTempPost(response.data.data);


    console.log("-------------------driver-----------------------");
    console.log(response.data.data);  

  }).catch(function(error) 
  {
    setIsLoading(false);        
    console.log(error.message);
  });    
 }


const FilterGrid =() => 
  {
      
    const Account_ID = getUserId(); 
    const searchparams = JSON.stringify({
      "accountid": Account_ID,
      "DriverName":fdriverName,
      "ContactNumber":fcontactName,
      "LicenceNumber": flicenceName,
      "OrderBy": ""
    });

    //alert(searchparams); 
    setPost([]); 
    axios.post(API_URL+'GpsSearchDriverAdvance/', searchparams, {  
      "headers":{"content-type": "application/json",},})
   .then(function (response) 
   {    
       
        setPost(response.data.data);      
        console.log(response.data.data);
   })
   .catch(function (error) 
   {
         toast.info("No data found !");
   });

  }
  const ResetDriverList=()=>
    {
      setFDriverName("");
      setFContactName("");
      setFlicenceName("");
      FillGrid(0);
    }
const changeHandler = (e) => 
  {   
    setFDriverName(e.target.value)
  } 
  const ContactchangeHandler = (e) => 
    {   
      setFContactName(e.target.value)
      //alert(e.target.name);
      if(e.target.name==='txtcontactno')
        {
              const re = /^[0-9\b]+$/;
              if (e.target.value === '' || re.test(e.target.value)) 
              {
                      //alert(e.target.value);
                      setFContactName(e.target.value);
              }
              else
              {
                      setFContactName("");                  
              }
              
        }
    } 
   const LicencechangeHandler=(e)=>
    {
      setFlicenceName(e.target.value)
    }
  const ChangePage = ({ selected }) => {
        
        setNumber(selected+1);
  };

  const sorting=(col)=>
  {
      try{
            if(order==="ASC")
            {
                    const sorted=[...post].sort((a,b)=>
                    a[col].toLowerCase() > b[col].toLowerCase() ? 1: -1
                    );
                    setPost(sorted);
                    setOrder("DSC");
            }
            if(order==="DSC")
            {
                    const sorted=[...post].sort((a,b)=>
                    a[col].toLowerCase() < b[col].toLowerCase() ? 1: -1
                    );
                    setPost(sorted);
                    setOrder("ASC");
            }
          }
          catch(error) 
          {
            console.log(error.message);
          }  
  }

const showAddDriverDetails=()=>
{
  //Clear text
  inputs.drName="";
  inputs.drContactNumber="";  
  inputs.drFatherName="";
  inputs.drContactNumber="";
  inputs.drLicenceNumber="";  
  inputs.drAddress="";
  inputs.drIdentityNumber="";

      axios.post(API_URL+'countries').then(response => {
              setDCountryData(response.data.data);        
       }).catch(function(error) 
       {
         console.log(error.message);
       }); ;
 
      axios.post(API_URL+'states?Country_ID=1').then(response => {
            setDStateData(response.data.data);  
      }).catch(function(error) 
      {
        console.log(error.message);
      }); 

      axios.get(API_URL+'cardtype').then(response => {
            setIdTypeData(response.data.data);        
      }).catch(function(error) 
      {
          console.log(error.message);
      }); 
        
      setShowAddDriver(true);   
   
         
}  

const closeDriverModal = () => {

    setShowAddDriver(false);
    setShowEditDriver(false);
    setViewDriver(false);
    FillGrid(statusId);         
}  
const closeViewDriverModal = () => {
    setShowAddDriver(false);
    setShowEditDriver(false);
    setViewDriver(false);
         
}  
const changeVHandler = (event) => {
  if(event.target.name==='drContactNumber')
  {
        const re = /^[0-9\b]+$/;
        if (event.target.value === '' || re.test(event.target.value)) 
        {
         
              const name = event.target.name;
             //alert(name);
             const value = event.target.value;
              setInputs(values => ({...values, [name]: value}))
        }
        else
        {
          setInputs(values => ({...values, ['drContactNumber']: ""}))
              
        }
        
  }
  else
  {
    const name = event.target.name;
    const value = event.target.value;
    setInputs(values => ({...values, [name]: value}))
  }
}
const changeDHandler = (event) => 
  {
  if(event.target.name==='drEContactNumber')
  {
        const re = /^[0-9\b]+$/;
        if (event.target.value === '' || re.test(event.target.value)) 
        {         
              const name = event.target.name;
             //alert(name);
             const value = event.target.value;
             setInputsEdit(values => ({...values, [name]: value}))
        }
        else
        {
          setInputsEdit(values => ({...values, ['drEContactNumber']: ""}))
              
        }        
  }
  else
  {
    const name = event.target.name;
    const value = event.target.value;
    setInputsEdit(values => ({...values, [name]: value}))
  }
  }
const DriverInsert=() => {

    //alert("Insert");
    console.log(inputs);

    var date1 = new Date(inputs.drLicenceIssueFrom);
    var date2 = new Date(inputs.drLicenceValidity);
//alert(date1)
//alert(date2)
   if((!inputs.drName) || inputs.drName ==='')
    {
        toast.error("Driver name is required.");
       return;
    }
    else if((!inputs.drFatherName) || inputs.drFatherName==='')
    {
        toast.error("Father name is required.");
       return;
    }
    else if((!inputs.drContactNumber) || inputs.drContactNumber==='')
    {
        toast.error("Contact number is required.");
       return;
    }
    else if((!inputs.drAddress) || inputs.drAddress==='')
    {
        toast.error("Address is required.");
       return;
    }
    else if(date1>= date2)
    {
      toast.error("Licence issue date should be less than expiry date.");
      return;
    }
    else
    {
            
           //Insert vehicle Details
           const vparams = JSON.stringify({

            "id": 0,
            "accountID": userId,
            "imeiNumber": "string",
            "driverName": inputs.drName ,
            "fatherName": inputs.drFatherName,
            "contactNumber": inputs.drContactNumber,
            "licenceNumber": inputs.drLicenceNumber===''?'0':inputs.drLicenceNumber,
            "licenceIssueFrom": inputs.drLicenceIssueFrom,
            "licenceValidity": inputs.drLicenceValidity,
            "address": inputs.drAddress,
            "identityNumber": inputs.drIdentityNumber===''?'0':inputs.drIdentityNumber,
            "issueCountryID": lCountryID,
            "issueStateID": lStateID,
            "countryID": rCountryID,
            "stateID": rStateID,
            "cardId":rIdType                   
           
        });
         //alert(vparams);
         //alert(API_URL+'NewDriverInsert/');
        axios.post(API_URL+'NewDriverInsert/', vparams, {
    
             "headers": 
             {
                    "content-type": "application/json",    
             },    
        })
          .then(function (response) 
          {
                                 
            if(response.data.validStatus === false)
            {
                toast.error(response.data.message); 
            }
            else
            {
                toast.success(response.data.message); 
              
                setInputs({});   
                setLCountryID(0);
                setLStateID(0);
                setRCountryID(0);
                setRStateID(0);
                setRIdType(0);
                             
           }
          })
    
          .catch(function (error) 
          {
               console.log(error);    
          });
            
            
          /*  */  
      
        }
          
}

const DriverEdit=()=> {
  //alert("Edit");
  console.log(inputsEdit);

  var date1 = new Date(inputsEdit.drLicenceIssueFrom);
  var date2 = new Date(inputsEdit.drLicenceValidity);

  if((!inputsEdit.drName) || inputsEdit.drName ==='')
   {
       toast.error("Driver name is required.");
      return;
   }
   else if((!inputsEdit.drEContactNumber) || inputsEdit.drEContactNumber==='')
   {
       toast.error("Contact number is required.");
      return;
   }
   else if((!inputsEdit.drAddress) || inputsEdit.drAddress==='')
   {
       toast.error("Address is required.");
      return;
   }
   else if(date1>= date2)
   {
    
      toast.error("Licence Issue date should be less than expiry date.");
      return;
    }
   else
   {
          //Insert vehicle Details
          const vparams = JSON.stringify({

           "id": inputsEdit.driverId,
           "accountID": userId,
           "imeiNumber": "string",
           "driverName": inputsEdit.drName ,
           "fatherName": inputsEdit.drFatherName,
           "contactNumber": inputsEdit.drEContactNumber,
           "licenceNumber": inputsEdit.drLicenceNumber,
           "licenceIssueFrom": inputsEdit.drLicenceIssueFrom,
           "licenceValidity": inputsEdit.drLicenceValidity,
           "address": inputsEdit.drAddress,
           "identityNumber": inputsEdit.drIdentityNumber,
           "issueCountryID": eLCountryID,
           "issueStateID": eLStateID,
           "countryID": eRCountryID,
           "stateID": eRStateID,
           "cardId":eIdType                      
          
       });
        //alert(vparams);
        //alert(API_URL+'NewDriverInsert/');
       axios.post(API_URL+'NewDriverInsert/', vparams, {
   
            "headers": 
            {
                   "content-type": "application/json",    
            },
   
       })
         .then(function (response) 
         {
                                
           if(response.data.validStatus === false)
           {
               toast.error(response.data.message); 
           }
           else
           {
               toast.success(response.data.message); 
               // setInputs({});   
               setLCountryID(0);
               setLStateID(0);
               setRCountryID(0);
               setRStateID(0);                            
          }
         })   
         .catch(function (error) 
         {
              console.log(error);    
         });               
     
       }
         
}
const showDetailsModal = (index) => {
     //alert(index);
    const vurls=API_URL+`ListofDriverByID?DriverID=${index}&AccountID=${userId}`;
    //alert(vurls);
    axios.get(vurls).then(response => {    
                    
                setSDriverName(response.data.data[0].driverName);
                setSFatherName(response.data.data[0].fatherName); 
                setSContactNumber(response.data.data[0].contactNumber); 
                setSLicenceNumber(response.data.data[0].licenceNumber); 
                setSLicenceIssueFrom(response.data.data[0].licenceIssueFrom); 
                setSLicenceValidity(response.data.data[0].licenceValidity); 
                setSLicenceCountry(response.data.data[0].issueCountry); 
                setSLicenceState(response.data.data[0].issueState);
                setSAddress(response.data.data[0].address); 
                setSResidenceCountry(response.data.data[0].country_Name); 
                setSResidenceState(response.data.data[0].state_Name); 
                setSIdentityNumber(response.data.data[0].identityNumber);     
                setSIdType(response.data.data[0].idType);                
                   
            }).catch(function(error) 
            {
              console.log(error.message);
            }); ;    
       
    setViewDriver(true);
    
}
const EnableDriverDetails=(index)=>{
  
  const ddurls=API_URL+`Driver_Delete?AccountID=${userId}&DriverID=${index}`;
  //alert(ddurls);
  axios.post(ddurls).then(response => {
    if(response.data.validStatus === false)
           {
               toast.error(response.data.message); 
           }
           else
           {
             FillGrid(0);
               toast.success(response.data.message); 
           }        
  }).catch(function(error) 
  {
    console.log(error.message);
  }); 

}
const DeleteDriverDetails=(index)=>{
  if(window.confirm('Do you want to disable the driver?'))
  {
  const ddurls=API_URL+`Driver_Delete?AccountID=${userId}&DriverID=${index}`;
  //alert(ddurls);
  axios.post(ddurls).then(response => {
    if(response.data.validStatus === false)
           {
               toast.error(response.data.message); 
           }
           else
           {
             FillGrid(0);
               toast.success(response.data.message); 
           }        
  }).catch(function(error) 
  {
    console.log(error.message);
  }); 
} 
else 
{
        toast.error('Disabled operation canceled.');
}
}
const showEditDriverDetails=(index) => {

  axios.post(API_URL+'countries').then(response => {
    setDCountryData(response.data.data);        
  }).catch(function(error) 
  {
    console.log(error.message);
  }); 

  axios.post(API_URL+'states?Country_ID=1').then(response => {
       setDStateData(response.data.data);  
  }).catch(function(error) 
  {
    console.log(error.message);
  }); 

  axios.get(API_URL+'cardtype').then(response => {
    setIdTypeData(response.data.data);        
  }).catch(function(error) 
  {
   console.log(error.message);
  }); 

  const durls=API_URL+`ListofDriverByID?DriverID=${index}&AccountID=${userId}`;
  //alert(durls);
  axios.get(durls).then(response => {                        
                    console.log("response.data.data");
                    console.log(response.data.data);
                    inputsEdit.driverId= index;
                    inputsEdit.drName = response.data.data[0].driverName;                    
                    inputsEdit.drFatherName = response.data.data[0].fatherName;         
                    inputsEdit.drEContactNumber = response.data.data[0].contactNumber;   
                    inputsEdit.drLicenceNumber = response.data.data[0].licenceNumber;                        
                    inputsEdit.drLicenceIssueFrom =  response.data.data[0].licenceIssueFrom;                         
                    inputsEdit.drLicenceValidity = response.data.data[0].licenceValidity;                          
                    inputsEdit.drAddress = response.data.data[0].address;                           
                    inputsEdit.drIdentityNumber = response.data.data[0].identityNumber; 
                    
                    setERCountryID(response.data.data[0].countryID);
                    setERStateID(response.data.data[0].stateID);  
                    setELCountryID(response.data.data[0].issueCountryID);
                    setELStateID(response.data.data[0].issueStateID);  
                    setEIdType(response.data.data[0].cardId);       
                                       
            }).catch(function(error) 
            {
              console.log(error.message);
            }); 
       
   
    setShowEditDriver(true);
}  
const ChangeLCountryID = (e) => {

  setLCountryID(e.target.value);
 
}
const ChangeLStateID = (e) => {

   setLStateID(e.target.value);   

}
const ChangeRCountryID = (e) => {

    setRCountryID(e.target.value);
 
}
const ChangeRIdType=(e)=>{
   setRIdType(e.target.value);
}
const ChangeEIdType=(e)=>{

      setEIdType(e.target.value);
}
const ChangeRStateID = (e) => {

    setRStateID(e.target.value);   

}

const ChangeELCountryID = (e) => {

  setELCountryID(e.target.value);
 
}
const ChangeELStateID = (e) => {

   setELStateID(e.target.value);   

}
const ChangeERCountryID = (e) => {

    setERCountryID(e.target.value);
 
}
const ChangeERStateID = (e) => {
    setERStateID(e.target.value);   
}

const exportStatus = e => {
 
  const value = e.target.value;
  setStatusId(e.target.value);
  FillGrid(value);
}

const exportToCSV=()=>
  {
    const newPost = post.map(({ driverID, accountID,issueCountryID,issueStateID,countryID,stateID,country_Name,state_Name,issueCountry,issueState,imgPath,imeiNumber, ...rest }) => rest);
     
    const ws= XLSX.utils.json_to_sheet(newPost);        
     var wscols = [
      {wch:5} ,
      {wch:20},
      {wch:20},
      {wch:20},
      {wch:20},
      {wch:20},
      {wch:20},
      {wch:40},
      {wch:20},
      {wch:10}              
    ];
 
    var wsrows = [
       {hpx: 30}
    ];
    
    ws['!cols'] = wscols;
    ws['!rows']=wsrows;
    
    let Heading = [['S.No.',	'Driver Name',	'Father Name',	'Contact Number',	'Licence Number',	'Licence Issue From',	'Licence Validity',	'Address',	'Identity Number',	'status']];
    const wb={Sheets:{Driver:ws},SheetNames:["Driver"]};
    XLSX.utils.sheet_add_aoa(ws, Heading);     
    const excelBuffer= XLSX.write(wb,{bookType:"xlsx",type:"array"});
    const data= new Blob([excelBuffer],{type:fileType});
    FileSaver.saveAs(data,"AvtDriverReport"+".xlsx");

}
const exportDownload = e => 
  {  
    
    const value = e.target.value; 
    if(value=="Excel")
    {
           exportToCSV();            
    }
    if(value=="PDF")
    {
          handlePrint(null, () => tableRef.current);
    }
  }

//const { onDownload } = useDownloadExcel({
  //currentTableRef: tableRef.current,
  //filename: "Driver Details",
  //sheet: "Drivers"
//});

const handlePrint = useReactToPrint({
documentTitle: "Device Details",
//pageStyle: `@media print {
  //@page {
 //   margin: 10;
 // }
// }`,
onBeforePrint: () => console.log("before printing..."),
onAfterPrint: () => console.log("after printing..."),
removeAfterPrint: true,
});


 // if (isLoading) 
  //{
 //  return <center>< LoadingSpinner/></center> ;
  //}
  return (
    <>
        <Modal isOpen={viewDriver}>
            <div class="modal-header">
            <h5 className='modal-title'>View Details</h5>
            <button type="button" class="btn-close" onClick={closeDriverModal}></button>
            </div>
            <div class="modal-body">
           
            <div className='row' >
            <span style={{"border-bottom": "1px solid #dadada", padding: "5px" ,"margin-bottom":"10px",fontSize:"14px"}}><b>Driver Details </b> </span> 
                           <div className='col-md-6 col-lg-4 form-group'>
                           <b>Driver Name : </b>
                           {sDriverName}
                           
                           </div>
                           <div className='col-md-6 col-lg-4 form-group'>
                           <b>Father Name : </b>
                           { sFatherName}
                            
                           </div>
                           <div className='col-md-6 col-lg-4 form-group'>
                           <b>Contact Number : </b>
                           {sContactNumber} 
                            
                           </div>
                           <div className='col-md-6 col-lg-4 form-group'>
                           <b>Document Number : </b>
                           {sIdentityNumber}                       
                           </div>
                           <div className='col-md-6 col-lg-4 form-group'>
                           <b>Document Type : </b>
                           {sIdType}
                           </div>
                           <div className='col-md-6 col-lg-4 form-group'></div>
                              
                           <div className='col-md-6 col-lg-4 form-group'>
                           <b>Residence Country : </b>
                           {sResidenceCountry}
                           </div>     
                           <div className='col-md-6 col-lg-4 form-group'>
                           <b>Residence State : </b>
                           {sResidenceState}
                           </div>
                           <div className='col-md-6 col-lg-4 form-group'>
                           <b>Address : </b>
                           {sAddress}
                           </div> 
                           <span style={{"border-bottom": "1px solid #dadada", padding: "5px" ,"margin-bottom":"10px",fontSize:"14px"}}><b>Licence Details </b> </span> 
                           <div className='col-md-6 col-lg-4 form-group'>
                           <b>Licence Number : </b>
                           {sLicenceNumber}
                           </div>
                           <div className='col-md-6 col-lg-4 form-group'>
                           <b>Issue Date : </b>
                           {sLicenceIssueFrom} 
                           </div>
                           <div className='col-md-6 col-lg-4 form-group'>
                           <b>Expiry Date : </b>
                           {sLicenceValidity} 
                           </div>
                           <div className='col-md-6 col-lg-4 form-group'>
                           <b>Issuing Country : </b>
                           {sLicenceCountry}
                           </div>
                           <div className='col-md-6 col-lg-4 form-group'>
                           <b> Issuing State/ Province : </b>
                           {sLicenceState}
                           </div>                 
                           <div className='col-md-6 col-lg-4 form-group' style={{"paddingTop":"50px"}}>
                           </div>
                           
            </div>
             
            </div>
          
      </Modal>
      <Modal isOpen={showAddDriver}>
            <div class="modal-header">
            <h5 className='modal-title'>Add Details</h5>
            <button type="button" class="btn-close" onClick={closeDriverModal}></button>
            </div>
            <div class="modal-body">
            <div className='row'>
            <span style={{"border-bottom": "1px solid #dadada", padding: "5px" ,"margin-bottom":"10px",fontSize:"14px"}}><b>Driver Details </b> </span>
            <div className='col-md-6 col-lg-4 form-group'>
            Driver Name <span style={{color:"red"}}>&nbsp;*</span>
            <input name="drName"  type="text" maxLength={50}  className="form-control"  value={inputs.drName || ""}  onChange={changeVHandler}/>
            </div>
            <div className='col-md-6 col-lg-4 form-group'>
            Father Name <span style={{color:"red"}}>&nbsp;*</span>
            <input name="drFatherName"  type="text"  maxLength={50} className="form-control"  value={inputs.drFatherName || ""}  onChange={changeVHandler}/>
            </div>
            <div className='col-md-6 col-lg-4 form-group'>
            Contact Number <span style={{color:"red"}}>&nbsp;*</span>
            <input name="drContactNumber"  type="text"  maxLength={10}  className="form-control"  value={inputs.drContactNumber || ""}  onChange={changeVHandler}/>
            </div>
            <div className='col-md-6 col-lg-4 form-group'>
            Document Number 
            <input name="drIdentityNumber"  type="text" maxLength={16}  className="form-control" value={inputs.drIdentityNumber || ""}  onChange={changeVHandler}/>
            </div>
            <div className='col-md-6 col-lg-4 form-group'>Document Type
            <select className="form-control" name="IDType" value={rIdType || ""} onChange={ChangeRIdType}  >
            <option value={0}>Select Id Type</option>
            {idTypeData.map((e, key) => {
               return <option key={key} value={e.cardId}>{e.cardType}</option>;
            })}
            </select>  
            </div>
            <div className='col-md-6 col-lg-4 form-group'>            
            </div>
            <div className='col-md-6 col-lg-4 form-group'>
            Residence Country 
            <select className="form-control" name="DCountry" value={rCountryID || ""} onChange={ChangeRCountryID}  >
            <option value={0}>Select Country</option>
            {dCountryData.map((e, key) => {
               return <option key={key} value={e.id}>{e.country_Name}</option>;
            })}
            </select>
            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            Residence State 
                            <select className="form-control slct" name="DState" value={rStateID || ""} onChange={ChangeRStateID} >
                            <option value={0}>Select State</option>
                             {dStateData.map((e, key) => {
                                    return <option key={key} value={e.id}>{e.state_Name}</option>;
                             })}
                            </select>
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            Address <span style={{color:"red"}}>&nbsp;*</span>
                            <input name="drAddress"  type="text"  maxLength={200} className="form-control" value={inputs.drAddress || ""}  onChange={changeVHandler}></input>
                            </div>                                                      
                            <span style={{"border-bottom": "1px solid #dadada", padding: "5px" ,"margin-bottom":"10px",fontSize:"14px"}}><b>Licence Details </b> </span>
                            <div className='col-md-6 col-lg-4 form-group'>                            
                            Licence Number
                            <input name="drLicenceNumber"  type="text" maxLength={16}  className="form-control" value={inputs.drLicenceNumber || ""}  onChange={changeVHandler}></input>
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            Issue Date 
                            <input name="drLicenceIssueFrom"  type="date"   className="form-control" value={inputs.drLicenceIssueFrom || ""}  onChange={changeVHandler}/>
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            Expiry Date
                            <input name="drLicenceValidity"  type="date"   className="form-control"  value={inputs.drLicenceValidity || ""}  onChange={changeVHandler}/>
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            Issuing Country 
                            <select className="form-control" name="DCountry" value={lCountryID || ""} onChange={ChangeLCountryID}  >
                            <option value={0}>Select Country</option>
                            {dCountryData.map((e, key) => {
                                return <option key={key} value={e.id}>{e.country_Name}</option>;
                            })}
                            </select>
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            Issuing State/ Province
                            <select className="form-control slct" name="DState" value={lStateID || ""} onChange={ChangeLStateID} >
                            <option value={0}>Select State</option>
                                {dStateData.map((e, key) => {
                                    return <option key={key} value={e.id}>{e.state_Name}</option>;
                                })}
                            </select>
                            </div>                            
                           
                            <div className='col-md-6 col-lg-4 form-group' style={{"paddingTop":"50px"}}>
                           </div>
                                
                    </div>
                   </div>
                  <div class="modal-footer justify-content-center">
                          <button className="btn btn-primary2" onClick={() => DriverInsert()}>Save</button>           
                  </div>  
      </Modal>
      <Modal isOpen={showEditDriver}>
            <div class="modal-header">
            <h5 className='modal-title'>Update Details</h5>
            <button type="button" class="btn-close" onClick={closeDriverModal}></button>
            </div>
            <div class="modal-body">
            <div className='row'>
            <span style={{"border-bottom": "1px solid #dadada", padding: "5px" ,"margin-bottom":"10px",fontSize:"14px"}}><b>Driver Details </b> </span>
                            <div className='col-md-6 col-lg-4 form-group'>
                            Driver Name <span style={{color:"red"}}>&nbsp;*</span>
                            <input name="drName"  type="text" maxLength={50}  className="form-control"  value={inputsEdit.drName || ""}  onChange={changeDHandler}/>
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            Father Name <span style={{color:"red"}}>&nbsp;*</span>
                            <input name="drFatherName"  type="text" maxLength={50}  className="form-control"  value={inputsEdit.drFatherName || ""}  onChange={changeDHandler}/>
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            Contact Number <span style={{color:"red"}}>&nbsp;*</span>
                            <input name="drEContactNumber"  type="text"   className="form-control" maxLength={10}  value={inputsEdit.drEContactNumber || ""}  onChange={changeDHandler}/>
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            Document Number 
                            <input name="drIdentityNumber"  type="text"  maxLength={16} className="form-control" value={inputsEdit.drIdentityNumber || ""}  onChange={changeDHandler}/>
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>Document Type
                            <select className="form-control" name="IDType" value={eIdType || ""} onChange={ChangeEIdType}  >
                            <option value={0}>Select Id Type</option>
                            {idTypeData.map((e, key) => {
                            return <option key={key} value={e.cardId}>{e.cardType}</option>;
                            })}
                            </select>  
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'></div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            Residence Country 
                            <select className="form-control" name="DCountry" value={eRCountryID || ""} onChange={ChangeERCountryID}  >
                            <option value={0}>Select Country</option>
                            {dCountryData.map((e, key) => {
                                return <option key={key} value={e.id}>{e.country_Name}</option>;
                            })}
                            </select>
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            Residence State 
                            <select className="form-control slct" name="DState" value={eRStateID || ""} onChange={ChangeERStateID} >
                            <option value={0}>Select State</option>
                            {dStateData.map((e, key) => {
                            return <option key={key} value={e.id}>{e.state_Name}</option>;
                            })}
                            </select>
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            Address <span style={{color:"red"}}>&nbsp;*</span>
                            <input name="drAddress"  type="text" maxLength={200}  className="form-control" value={inputsEdit.drAddress || ""}  onChange={changeDHandler}></input>
                            </div>                          
                            <span style={{"border-bottom": "1px solid #dadada", padding: "5px" ,"margin-bottom":"10px",fontSize:"14px"}}><b>Licence Details </b> </span>
                            <div className='col-md-6 col-lg-4 form-group'>
                            Licence Number
                            <input name="drLicenceNumber"  type="text" maxLength={16}  className="form-control" value={inputsEdit.drLicenceNumber || ""}  onChange={changeDHandler}></input>
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            Issue Date  
                            <input name="drLicenceIssueFrom"  type="date"   className="form-control" value={inputsEdit.drLicenceIssueFrom || ""}  onChange={changeDHandler}/>
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            Expiry Date
                            <input name="drLicenceValidity"  type="date"   className="form-control"  value={inputsEdit.drLicenceValidity || ""}  onChange={changeDHandler}/>
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            Issuing Country 
                            <select className="form-control" name="DCountry" value={eLCountryID || ""} onChange={ChangeELCountryID}  >
                            <option value={0}>Select Country</option>
                            {dCountryData.map((e, key) => {
                                return <option key={key} value={e.id}>{e.country_Name}</option>;
                            })}
                            </select>
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            Issuing State/ Province
                            <select className="form-control slct" name="DState" value={eLStateID || ""} onChange={ChangeELStateID} >
                            <option value={0}>Select State</option>

                                {dStateData.map((e, key) => {
                                    return <option key={key} value={e.id}>{e.state_Name}</option>;
                                })}

                            </select>
                            </div>                                                      
                            <div className='col-md-6 col-lg-4 form-group' style={{"paddingTop":"50px"}}>
                           </div>                         
                           
                          
                                
            </div>
            </div>
            <div class="modal-footer justify-content-center">
            <button className="btn btn-primary2" onClick={() => DriverEdit()}>Update</button> 
                       
             </div>  
      </Modal>
   
      <div className="top-bar clearfix">
      <div className="row">
       
       <div className="col-md-4">
       <h2> Drivers  </h2>   
       </div>
       <div className="col-md-8 text-right">
       <button type="submit" id="Save" onClick={() => showAddDriverDetails()} className="btn btn-new" > New </button>        
       <select onChange={exportStatus} className="btn btn-primary" name="Export"  value={statusId} >               
       <option value={"0"}>All</option>  
       <option value={"1"}>Enabled</option>  
       <option value={"2"}>Disabled</option>            
       </select> 
       <select onChange={exportDownload}  className="btn btn-primary" name="Download"   >
       <option value={"Download"}>Download</option>    
       <option value={"Excel"}>Excel</option>    
       <option value={"PDF"}>PDF</option>                     
       </select>
       </div>
       </div>
      </div>      
<div className="container-fluid p-3">
<div class="card mb-2 shadow no-border border-0">
  <div class="card-body">
    <div class="row align-items-end">  
      <div class="col-sm-3 col-lg-2">Driver Name<input type="text" class="form-control" tabindex="1" id="txtdriver" name="txtdriver" value={fdriverName} onChange={changeHandler} maxlength="50"/>
      </div> 
      <div class="col-sm-3 col-lg-2">Contact#<input type="text" class="form-control" tabindex="1" maxLength={10} id="txtcontactno"  name="txtcontactno" value={fcontactName} onChange={ContactchangeHandler} />
      </div>  
      <div class="col-sm-3 col-lg-2">Licence#<input type="text" class="form-control" tabindex="1" maxLength={10} id="txtlicenceo"  name="txtlicenceo" value={flicenceName} onChange={LicencechangeHandler} />
      </div>    
      <div class="col-sm-4 col-lg-2">
      <button type="button" class="btn btn-primary2 mt-20" tabindex="6" id="btnsearch" onClick={FilterGrid} >Search</button>
      <button type="button" class="btn btn-secondary mt-20" id="btnreset" tabindex="7" onClick={ResetDriverList}>Reset
      </button></div>
      </div>    
  </div></div>
  {/* <div class="card mb-3 shadow no-border border-0">*/}
  <div className="container-fluid p-3">
     <div class="card mb-3 shadow no-border border-0">
     <div class="card-body p-0">
  <table ref={tableRef} class="table table-striped table-bordered table-hover" style={{width:"100%"}}>
            <thead>
            <tr>
                <th style={{textAlign:"center"}} width="5%">S.No.</th>
                <th width="10%" onClick={()=>sorting("driverName") } style={{textAlign:"center","cursor": "pointer"}} >Driver Name &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="10%" onClick={()=>sorting("fatherName") } style={{textAlign:"center","cursor": "pointer"}}>Father Name &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="10%" onClick={()=>sorting("contactNumber") } style={{textAlign:"center","cursor": "pointer"}}>Contact Number &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="10%" onClick={()=>sorting("licenceNumber") } style={{textAlign:"center","cursor": "pointer"}}>Licence Number &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="10%" onClick={()=>sorting("licenceIssueFrom") } style={{textAlign:"center","cursor": "pointer"}}>Licence Issue Date &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="11%" onClick={()=>sorting("licenceValidity") } style={{textAlign:"center","cursor": "pointer"}}>Licence Expiry Date &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="11%" onClick={()=>sorting("address") } style={{textAlign:"center","cursor": "pointer"}}>Address &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="11%" onClick={()=>sorting("identityNumber") } style={{textAlign:"center","cursor": "pointer"}}>Identity Number &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="5%" onClick={()=>sorting("status") } style={{textAlign:"center","cursor": "pointer"}}>Status &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th style={{textAlign:"center"}} width="7%">Action</th>
            </tr>
            </thead>
            <tbody>
              {currentPost.map((Val) => {                 
              return (
              <>
              <tr key={Val.id}>
              <td style={{textAlign:"center"}}> {Val.id}</td>
              <td>{Val.driverName}</td>
              <td>{Val.fatherName}</td>
              <td>{Val.contactNumber}</td>
              <td>{Val.licenceNumber}</td>
              <td>{Val.licenceIssueFrom}</td>
              <td>{Val.licenceValidity}</td>
              <td>{Val.address}</td>
              <td>{Val.identityNumber}</td>  
              <td>{Val.status}</td>  
              <td style={{textAlign:"center", fontSize:"14px"}}>
              <i onClick={() => showDetailsModal(Val.driverID)} style={{ color:"green", cursor:'pointer'}} className="fa-solid fa-list" title="View Details"></i>
              &nbsp;&nbsp; <i onClick={() => showEditDriverDetails(Val.driverID)} style={{ color:"rgb(13, 110, 253)", cursor:'pointer'}} className="fa-solid fa-pen-to-square" title="Update Details"></i>
              &nbsp;&nbsp; <i onClick={() => EnableDriverDetails(Val.driverID)} style={{ color:"green", cursor:'pointer'}} className={Val.status==="Enabled"?"display:block":"display:none fa-solid fa-trash-arrow-up"}  title="Enable"></i>
              <i onClick={() => DeleteDriverDetails(Val.driverID)} style={{ color:"red", cursor:'pointer'}} className={Val.status==="Disabled"?"display:block":"display:none fa-solid fa-trash"} title="Disable"></i>
             </td>          
              </tr>
              </>
              );
              })}
            </tbody>
          </table>
          <ReactPaginate  previousLabel={"<<"}  nextLabel={">>"}  pageCount={PageCount}  onPageChange={ChangePage}     
            disableInitialCallback={true}  initialPage={0}
            containerClassName={'pagination justify-content-end'}
            pageClassName={'page-item'}
            pageLinkClassName={'page-link'}
            previousClassName={'page-item'}
            previousLinkClassName={'page-link'}
            nextClassName={'page-item'}
            nextLinkClassName={'page-link'}
            breakClassName={'page-item'}
            breakLinkClassName={'page-link'}
            activeClassName={'active'}></ReactPaginate>
        </div>
 </div>  </div>  
  </div>
      <ToastContainer position="bottom-right" autoClose={4000} theme="light"/> 
    </>
  );
}; 
export default CDriverList;